/**
 * This is an auto generated file - do not modify manually!
 * Colors are fetched via Figma api
 */
var colors = {
  /**
   * Full Black '#000000'
   */
  fullBlack: '#000000',

  /**
   * Professional Grey '#111111'
   */
  professionalGrey: '#111111',

  /**
   * Raisin Grey '#222222'
   */
  raisinGrey: '#222222',

  /**
   * Mine Shaft Grey '#292929'
   */
  mineShaftGrey: '#292929',

  /**
   * Ink Grey '#333333'
   */
  inkGrey: '#333333',

  /**
   * Emperor Grey '#555555'
   */
  emperorGrey: '#555555',

  /**
   * October Grey '#777777'
   */
  octoberGrey: '#777777',

  /**
   * Silver Grey '#999999'
   */
  silverGrey: '#999999',

  /**
   * Fog Grey '#c9c9c9'
   */
  fogGrey: '#c9c9c9',

  /**
   * Cloud Grey '#f2f2f2'
   */
  cloudGrey: '#f2f2f2',

  /**
   * Light Grey '#f7f7f7'
   */
  lightGrey: '#f7f7f7',

  /**
   * Snow White '#ffffff'
   */
  snowWhite: '#ffffff',

  /**
   * Dusky Blue '#1c3a5c'
   */
  duskyBlue: '#1c3a5c',

  /**
   * Composed Blue '#325285'
   */
  composedBlue: '#325285',

  /**
   * Cushy Blue '#406aad'
   */
  cushyBlue: '#406aad',

  /**
   * Water Blue '#78a0d4'
   */
  waterBlue: '#78a0d4',

  /**
   * Placid Purple '#5a367a'
   */
  placidPurple: '#5a367a',

  /**
   * Jammy Purple '#834db3'
   */
  jammyPurple: '#834db3',

  /**
   * Ethereal Purple '#b27ee0'
   */
  etherealPurple: '#b27ee0',

  /**
   * Punch Red '#b83e4d'
   */
  punchRed: '#b83e4d',

  /**
   * Power Red '#d25564'
   */
  powerRed: '#d25564',

  /**
   * Soft Red '#f08b9a'
   */
  softRed: '#f08b9a',

  /**
   * Dusk Red-Orange '#9c4122'
   */
  duskRedOrange: '#9c4122',

  /**
   * Haze Red-Orange '#bf4f2a'
   */
  hazeRedOrange: '#bf4f2a',

  /**
   * Energetic Red-Orange '#eb6437'
   */
  energeticRedOrange: '#eb6437',

  /**
   * Fall Red-Orange '#ff9673'
   */
  fallRedOrange: '#ff9673',

  /**
   * Fine Orange '#d6921c'
   */
  fineOrange: '#d6921c',

  /**
   * Energetic Orange '#ebae44'
   */
  energeticOrange: '#ebae44',

  /**
   * Stoical Orange '#ffc663'
   */
  stoicalOrange: '#ffc663',

  /**
   * Old Yellow '#cfbd3a'
   */
  oldYellow: '#cfbd3a',

  /**
   * Aureolin Yellow '#f5e150'
   */
  aureolinYellow: '#f5e150',

  /**
   * Mini Yellow '#fff07a'
   */
  miniYellow: '#fff07a',

  /**
   * Frog Green '#317548'
   */
  frogGreen: '#317548',

  /**
   * Deep Green '#3e9458'
   */
  deepGreen: '#3e9458',

  /**
   * Optimistic Green '#5ac37d'
   */
  optimisticGreen: '#5ac37d',

  /**
   * Light Green '#8bf0ab'
   */
  lightGreen: '#8bf0ab',

  /**
   * Forest Green '#377a6c'
   */
  forestGreen: '#377a6c',

  /**
   * Vibrant Green '#4b9684'
   */
  vibrantGreen: '#4b9684',

  /**
   * Electric Green '#78dec8'
   */
  electricGreen: '#78dec8',

  /**
   * Hyper green '#93f2dc'
   */
  hyperGreen: '#93f2dc'
};

export { colors };
